import React, {useCallback, useState} from "react";

import {connect} from "react-redux";
import Button from "features/components/button";
import {__} from "services/i18n";
import Loading from "features/components/loading";
import ProfileEditForm from "features/forms/profile-edit";
import {
    profileData,
    profileGetLoading,
    profileSaveError,
    profileSaveLoading
} from "store/reducer/user/profile/selectors";
import {getProfileStart, saveProfileStart} from "store/reducer/user/profile/reducer";
import {profileEditMode} from "features/pages/profile/edit-profile/selectors";
import {enableProfileEditMode} from "features/pages/profile/edit-profile/reducer";
import Text from "features/components/text";

/* istanbul ignore next */
const mapStateToProps = state => ({
    profile_get_loading: profileGetLoading(state),
    profile: profileData(state),
    profile_save_loading: profileSaveLoading(state),
    profile_error: profileSaveError(state),
    profileEdit: profileEditMode(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getProfileStart,
    saveProfileStart,
    enableEditMode: enableProfileEditMode
};

export const ProfileEdit = (props) => {
    const {profile, profile_get_loading, getProfileStart, profile_save_loading, saveProfileStart, profileEdit, enableEditMode, profile_error} = props;
    const [profileVal, setProfile] = useState(props.profile);
    React.useEffect(() => {
        getProfileStart();
    }, [getProfileStart]);

    const doSaveProfile = useCallback(() => {
        saveProfileStart(profileVal);
    }, [profileVal, saveProfileStart]);

    return <>
        {profile_get_loading ? <Loading/> :
            <>
                <div className="row reverse">
                    {!profileEdit ?
                        <Button title={__("buttons.edit-data")}
                                onClick={() => enableEditMode()}
                                type={"outlined"}
                        /> :
                        <Button title={__("buttons.save-data")}
                                onClick={doSaveProfile}
                                disabled={!profileVal.valid}
                                status={profile_save_loading ? "loading" : "success"}
                        />
                    }
                </div>
                {profile_error.inError && <Text size={16} color={"danger"}>{__(profile_error.error)}</Text>}
                <ProfileEditForm disabled={!profileEdit} {...profile} onChange={setProfile}/>
            </> }
    </>
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEdit);